module.exports = __webpack_public_path__ + "images/emoji/zzz.3f9e3e9657e03688e70b.png";